module.exports = __webpack_public_path__ + "img/mobile-support-Zs.bf2f973c.svg";